export default __webpack_public_path__ + "static/media/palvelut-white.7264d1df.svg";